export default __webpack_public_path__ + "fad7cd2f61051969e1b83c4752afd076.png";